type NormalizedUrl = {
  protocol: string;
  hostname: string;
  port: string;
  pathname: string;
};

export function getDefaultPageHref(): string | undefined {
  return (globalThis as { window?: { location?: { href?: string } } }).window?.location?.href;
}

function safeDecodePathname(pathname: string): string {
  try {
    return decodeURI(pathname);
  } catch {
    return pathname;
  }
}

function isDefaultPort(protocol: string, port: string): boolean {
  return (protocol === 'http:' && port === '80') || (protocol === 'https:' && port === '443');
}

export function normalizeOriginPathUrl(
  rawUrl: string | null | undefined,
  options: { pageHref?: string } = {},
): string | null {
  if (rawUrl === null || rawUrl === undefined) return null;

  try {
    const URLCtor = (globalThis as { URL?: new (url: string, base?: string) => NormalizedUrl }).URL;
    if (!URLCtor) return null;

    const url = new URLCtor(rawUrl, options.pageHref ?? getDefaultPageHref());
    const protocol = url.protocol.toLowerCase();
    const hostname = url.hostname.toLowerCase();
    const port = url.port && !isDefaultPort(protocol, url.port) ? `:${url.port}` : '';
    const pathname = encodeURI(safeDecodePathname(url.pathname));
    return `${protocol}//${hostname}${port}${pathname}`;
  } catch {
    return null;
  }
}
